import React from "react";
import { Helmet } from "react-helmet";
import MegaHeader from "../components/MegaHeader/MegaHeader";
import Footer from "../components/footer/Footer";
import SoftwareCompanyCta from "../components/software-company-cta/SoftwareCompanyCta";
import ServicesPageBanner from "../components/services-page-banner/ServicesPageBanner";
import TrustedPartner from "../components/trustedPartners/TrustedPartner";
import OurServices from "../components/our-services/OurServices";
import FAQ from "../components/Fqas/FAQ";
import TrendsInsights from "../components/trends-n-insights/TrendsInsights";
import DarkRoadMap from "../components/dark-roadmap/darkRoadMap";
import SimpleModels from "../components/simpleEngagementModels";
import PioneeringChange from "../components/pioneeringChange/PioneeringChange";
import tabData from "../data/industryData";
import { useTranslation } from "react-i18next";
import NewTestimonials from "../components/new-testimonials/NewTestimonials";
import WhyChooseUs from "../components/why-choose-us/WhyChooseUs";
import NewCaseStudySection from "../components/new-case-study-section/NewCaseStudySection";
import NewBenefitsSection from "../components/new-banefits-section/NewBenefitsSection";
import IndustriesTabs from "../components/industries-tabs/IndustriesTabs";
import CoverTheStack from "../components/coverthestack/CoverTheStack";
import ChatBotWorkFlow from "../components/chatbbot-workflow/ChatBotWorkFlow";
import IntigrationIconsSection from "../components/integration-icons-section/IntigrationIconsSection";
import MegaMenu from "../components/MegaMenu/MegaMenu";
import AreasWeServe from "../components/areas-we-serve/AreasWeServe";
import { AiChatBotPageDataCalifornia } from "../data/ai-chatbot-data-california";
import { AiChatBotPageData } from "../data/ai-chatbot-data";
import TechStack from "../components/techstack/TechStack";
import ChatbotIntigratedSection from "../components/ChatBotIntigratedSection/ChatbotIntigratedSection";
import SecurityFIrstSection from "../components/SecurityFirstSection/SecurityFIrstSection";
import NewRoadMap from "../components/new-raodmap-section/NewRoadMap";
import ModelAgnostic from "../components/ModelAgnostic/ModelAgnostic";
import ChatbotBanner from "../components/ChatbotBanner/ChatbotBanner";

const AIChatBotServicesCalifornia = () => {

    const { t } = useTranslation("footer");
    const footerCtaContent = t("footerCtaContent", { returnObjects: true });

    const { t: stackData } = useTranslation("aiDevelopmentPageContent");
    const coverTheStackData = stackData("aiDevCoverTheStackSection", {
        returnObjects: true,
    });

    return (
        <>
            <Helmet>
                <title>Custom AI Chatbot Development Company in California | Bitsclan</title>
                <meta
                    name="description"
                    content="Bitsclan is a custom AI chatbot development company in California offering chatbot development services to automate workflows & enhance customer experiences."
                />
                <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
                <link rel="canonical" href="https://bitsclan.com/california-ai-chatbot-development-services" />
            </Helmet>

            <MegaMenu />

            <ChatbotBanner
                shortHeading="AI Chatbot Development Services in California"
                mainHeading="Driving <span>Digital Growth</span> Through Chatbot Excellence in California"
                description="Known as one of the best AI chatbot development companies, we feel proud of delivering custom AI chatbot development services in California that align with your business goals. From intelligent automation to conversational AI, our team develops AI solutions that integrate seamlessly with your existing systems."
                bannerImage="/images/why-us-section/chatbot-banner.png"
            />
            <TrustedPartner category={"chatbot"} showGoogleIcons={true} heading="Trusted & Partnered by Businesses Worldwide to Build Smarter Chatbot Solutions" />

            <OurServices
                shortHeading={"California AI Chatbot Solutions to Transform Customer Experience"}
                buttonText="Hire Local California Chatbot Developer"
                servicesCardsData={AiChatBotPageDataCalifornia?.services}
                mainHeading="Transforming Workflows Through AI Chatbot Innovation"
                // mainHeading=" No Matter What You are Building, We Can Help with Expert <span>AI Solutions</span>"
                description="As a leading AI chatbot development company in California, we deliver value-driven solutions that automate routine tasks, optimize workflows, & enhance customer engagement, helping businesses improve efficiency & achieve long-term growth."
            />

            <NewTestimonials
                shortHeading={AiChatBotPageDataCalifornia?.testimonialData?.shortHeading}
                mainHeading={AiChatBotPageDataCalifornia?.testimonialData?.mainHeading}
                description={AiChatBotPageDataCalifornia?.testimonialData?.description}
                content={AiChatBotPageDataCalifornia?.testimonialData?.testimonials}
            />

            <WhyChooseUs
                heading={AiChatBotPageDataCalifornia?.whyUsSectionData?.heading}
                greenHeading={AiChatBotPageDataCalifornia?.whyUsSectionData?.greenHeading}
                content={AiChatBotPageDataCalifornia?.whyUsSectionData?.content}
                shortHeading={AiChatBotPageDataCalifornia?.whyUsSectionData?.shortHeading}
                stats={AiChatBotPageDataCalifornia?.whyUsSectionData?.stats}
                cta={AiChatBotPageDataCalifornia?.whyUsSectionData?.cta}
                sectionImage={AiChatBotPageDataCalifornia?.whyUsSectionData?.image}
            />

            <NewCaseStudySection
                heading={AiChatBotPageDataCalifornia?.caseStudyContent?.heading}
                shortHeading={AiChatBotPageDataCalifornia?.caseStudyContent?.shortHeading}
                description={AiChatBotPageDataCalifornia?.caseStudyContent?.description}
                filter={"chatbot"}
            />

            <ChatbotIntigratedSection content={AiChatBotPageData?.integrationsData} />

            <SimpleModels content={AiChatBotPageDataCalifornia?.engagementModels} />

            <TechStack content={AiChatBotPageData?.techStackData} />

            <NewBenefitsSection />

            {/* <ChatBotWorkFlow /> */}

            {/* <IntigrationIconsSection content={AiChatBotPageDataCalifornia?.chatbotIntigration} /> */}

            <PioneeringChange
                shortHeading="Industries We Serve"
                tabData={AiChatBotPageDataCalifornia?.industriesSectionMain}
                greenHeading={"Solutions Built for the Unique Demands of Every Industry"}
                mainHeading={"Specialized Chatbot "}
                content={"Driving innovation & transforming industries with advanced ai chatbot development expertise & actionable insights."}
                serviceTags={[
                    { title: "AI Chatbots", link: "/ai-chatbot-development-services" },
                    { title: "Virtual Assistants", link: "/ai-automation-agency" },
                    { title: "Conversational AI", link: "/generative-ai-development-services" }
                ]}
            />

            {/* <IndustriesTabs defaultTab={"Healthcare"} shortHeading="Industries We Serve" mainheading="Our Industry-Specific Chatbot Development Expertise" description="Driving innovation & transforming industries with advanced ai chatbot development expertise & actionable insights." /> */}

            <SecurityFIrstSection />

            <ModelAgnostic />

            <CoverTheStack
                whereStart={"Deep learning frameworks"}
                shortHeading={"Technology Stack for Chatbot Development"}
                mainHeading={"Foundational Technologies Driving Conversational Intelligence"}
                subHeading={
                    "The right technology stack for chatbot development will depend on your intended use cases & channels. We engage with the leading providers from Microsoft Azure & AWS to Google Cloud for dependable, secure, & scalable solutions."
                }
                tabs={AiChatBotPageDataCalifornia?.techStack?.tabs}
                tabItems={AiChatBotPageDataCalifornia?.techStack?.tabItems}
            />

            <NewRoadMap roadmapContent={AiChatBotPageData?.roadmapContent} />

            <TrendsInsights
                category="ai-developmet"
                heading={AiChatBotPageDataCalifornia?.trendingInsights.heading}
                description={AiChatBotPageDataCalifornia?.trendingInsights.description}
            />

            <FAQ
                faqs={AiChatBotPageDataCalifornia.faqSection.questionAnswers}
                mainHeading={AiChatBotPageDataCalifornia.faqSection.heading}
            />

            <AreasWeServe />

            <SoftwareCompanyCta content={AiChatBotPageDataCalifornia?.companyCta} />
            <Footer />
        </>
    )
}

export default AIChatBotServicesCalifornia